import React from 'react';
import { Link } from 'react-router-dom';
import cl from './Hero.module.css';
import { IconArrowRight } from '../../components/icons';
import useReveal from '../../hooks/useReveal';

// Большой первый экран. Тёмный градиент с анимированными blob'ами,
// заголовок с акцент-градиентом, 2 CTA, бейджи под подзаголовком,
// справа коллаж скриншотов трёх платформ.

export default function Hero() {
    const revealRef = useReveal();
    return (
        <section className={cl.hero} ref={revealRef}>
            {/* Анимированные пятна на фоне */}
            <div className={cl.blob} style={{ '--blob-color': '#3b82f6', '--blob-pos': 'top-left' }}/>
            <div className={cl.blob} style={{ '--blob-color': '#a855f7', '--blob-pos': 'bottom-right' }}/>
            <div className={cl.blob} style={{ '--blob-color': '#ec4899', '--blob-pos': 'center' }}/>

            <div className={cl.inner}>
                <div className={cl.left}>
                    <div className={cl.badge} data-reveal="down" style={{ '--reveal-delay': '0ms' }}>
                        <span className={cl.dot}></span>
                        Для детских образовательных центров
                    </div>

                    <h1 className={cl.title} data-reveal="up" style={{ '--reveal-delay': '120ms' }}>
                        Готовая <span className={cl.accent}>IT-программа</span><br/>
                        для вашего центра
                    </h1>

                    <p className={cl.subtitle} data-reveal="up" style={{ '--reveal-delay': '220ms' }}>
                        Подключите учеников к двум развитым платформам:
                        <b> Майнкрафтия </b>(программирование, Scratch, Python,
                        Minecraft-серверы) и <b>Роботехника</b> (электроника,
                        3D-моделирование, Arduino). Плюс свой кабинет для учёта
                        учеников, оплат и журнала посещений.
                    </p>

                    <div className={cl.cta} data-reveal="up" style={{ '--reveal-delay': '320ms' }}>
                        <Link to="/registration" className={cl.btnPrimary}>
                            Попробовать бесплатно
                            <span className={cl.arrow}><IconArrowRight width={18} height={18}/></span>
                        </Link>
                        <a href="#how-it-works" className={cl.btnGhost}>
                            Как это работает
                        </a>
                    </div>

                    <div className={cl.bullets} data-reveal-stagger>
                        <div className={`${cl.bullet} ${cl.bulletBlue}`}>
                            <span className={cl.bulletIcon} aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M4 5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Z"
                                        stroke="currentColor" strokeWidth="2"/>
                                    <path d="M14 3v6h6" stroke="currentColor" strokeWidth="2"/>
                                </svg>
                            </span>
                            <span className={cl.bulletNum}>20+</span>
                            <span className={cl.bulletText}>курсов</span>
                        </div>
                        <div className={`${cl.bullet} ${cl.bulletViolet}`}>
                            <span className={cl.bulletIcon} aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 3 2 8l10 5 10-5-10-5Z" stroke="currentColor" strokeWidth="2"
                                        strokeLinejoin="round"/>
                                    <path d="m2 16 10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2"
                                        strokeLinejoin="round"/>
                                </svg>
                            </span>
                            <span className={cl.bulletNum}>700+</span>
                            <span className={cl.bulletText}>уроков</span>
                        </div>
                        <div className={`${cl.bullet} ${cl.bulletPink}`}>
                            <span className={cl.bulletIcon} aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <path d="m5 13 4 4L19 7" stroke="currentColor" strokeWidth="2.4"
                                        strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                            <span className={cl.bulletNum}>30 000+</span>
                            <span className={cl.bulletText}>задач</span>
                        </div>
                        <div className={`${cl.bullet} ${cl.bulletGreen}`}>
                            <span className={cl.bulletIcon} aria-hidden>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="8" width="18" height="10" rx="3"
                                        stroke="currentColor" strokeWidth="2"/>
                                    <path d="M7 8V5M17 8V5M7 22v-4M17 22v-4M1 12h2M1 16h2M21 12h2M21 16h2"
                                        stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            </span>
                            <span className={cl.bulletNum}>50</span>
                            <span className={cl.bulletText}>проектов Arduino</span>
                        </div>
                    </div>
                </div>

                <div className={cl.right} data-reveal="zoom" style={{ '--reveal-delay': '480ms' }}>
                    <HeroCollage/>
                </div>
            </div>

            {/* Стрелка-приглашение скролла */}
            <div className={cl.scrollHint}>
                <span></span>
            </div>
        </section>
    );
}


/** Декоративный коллаж: три карточки платформ с лёгкой 3D-перспективой. */
function HeroCollage() {
    return (
        <div className={cl.collage}>
            <div className={`${cl.card} ${cl.cardBack}`}>
                <div className={cl.cardTag} style={{ background: '#a855f7' }}>Роботехника</div>
                <RobotehnickPreview/>
            </div>
            <div className={`${cl.card} ${cl.cardMid}`}>
                <div className={cl.cardTag} style={{ background: '#3b82f6' }}>Майнкрафтия</div>
                <MinecraftiaPreview/>
            </div>
            <div className={`${cl.card} ${cl.cardFront}`}>
                <div className={cl.cardTag} style={{ background: '#10b981' }}>Админ-панель</div>
                <AdminPreview/>
            </div>
        </div>
    );
}


/* === Декоративные SVG-превью трёх платформ === */

function MinecraftiaPreview() {
    return (
        <svg viewBox="0 0 320 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
            <defs>
                <linearGradient id="mc-bg" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#1e3a8a"/>
                    <stop offset="100%" stopColor="#0c1233"/>
                </linearGradient>
            </defs>
            <rect width="320" height="200" fill="url(#mc-bg)"/>
            {/* «Пиксели» Minecraft */}
            <g opacity="0.4">
                {Array.from({ length: 16 }).map((_, i) =>
                    Array.from({ length: 10 }).map((_, j) => (
                        <rect key={`${i}-${j}`} x={i*20} y={j*20} width="20" height="20"
                            fill={(i + j) % 3 === 0 ? '#10b981' : 'transparent'}
                            opacity={(i + j) % 7 === 0 ? 0.6 : 0.15}/>
                    ))
                )}
            </g>
            {/* «Окно урока» — серединная карточка */}
            <rect x="60" y="50" width="200" height="100" rx="10" fill="rgba(255,255,255,0.95)"/>
            <rect x="72" y="62" width="80" height="8" rx="2" fill="#3b82f6"/>
            <rect x="72" y="78" width="140" height="4" rx="2" fill="#cbd5e1"/>
            <rect x="72" y="88" width="120" height="4" rx="2" fill="#cbd5e1"/>
            <rect x="72" y="98" width="100" height="4" rx="2" fill="#cbd5e1"/>
            <rect x="72" y="118" width="60" height="20" rx="4" fill="#10b981"/>
            <text x="102" y="132" textAnchor="middle" fill="#fff" fontSize="11" fontWeight="700"
                fontFamily="Inter, sans-serif">Решено</text>
        </svg>
    );
}

function RobotehnickPreview() {
    return (
        <svg viewBox="0 0 320 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
            <defs>
                <linearGradient id="rt-bg" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#4a1d6f"/>
                    <stop offset="100%" stopColor="#1e0a36"/>
                </linearGradient>
            </defs>
            <rect width="320" height="200" fill="url(#rt-bg)"/>
            {/* Сетка точек breadboard */}
            {Array.from({ length: 12 }).map((_, x) =>
                Array.from({ length: 8 }).map((_, y) => (
                    <circle key={`${x}-${y}`} cx={30 + x*24} cy={28 + y*22} r="1.2"
                        fill="#a855f7" opacity="0.35"/>
                ))
            )}
            {/* Схема: батарея → резистор → LED */}
            <rect x="40" y="90" width="32" height="20" rx="3" fill="#fbbf24" stroke="#1e293b" strokeWidth="2"/>
            <line x1="72" y1="100" x2="120" y2="100" stroke="#fff" strokeWidth="3"/>
            <rect x="120" y="90" width="50" height="20" rx="4" fill="#d97706"/>
            {[6, 14, 22, 30, 38].map(x => (
                <rect key={x} x={120+x} y="90" width="3" height="20" fill="#fff" opacity="0.7"/>
            ))}
            <line x1="170" y1="100" x2="210" y2="100" stroke="#fff" strokeWidth="3"/>
            <ellipse cx="225" cy="100" rx="16" ry="18" fill="#ef4444">
                <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite"/>
            </ellipse>
            <ellipse cx="220" cy="94" rx="4" ry="5" fill="#fff" opacity="0.6"/>
            {/* Бегущий ток */}
            <circle r="3" fill="#fbbf24">
                <animateMotion dur="2s" repeatCount="indefinite"
                    path="M 56 100 L 120 100 L 170 100 L 225 100"/>
            </circle>
            {/* 3D-куб справа */}
            <g transform="translate(280 50)">
                <animateTransform attributeName="transform" type="rotate"
                    values="0 280 50;360 280 50" dur="12s" repeatCount="indefinite"/>
                <path d="M -20 -10 L 0 -20 L 20 -10 L 20 14 L 0 24 L -20 14 Z"
                    fill="#3b82f6" stroke="#0f172a" strokeWidth="1.5"/>
                <path d="M -20 -10 L 0 0 L 20 -10 M 0 0 L 0 24"
                    fill="none" stroke="#0f172a" strokeWidth="1.5"/>
            </g>
        </svg>
    );
}

function AdminPreview() {
    return (
        <svg viewBox="0 0 320 200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
            <rect width="320" height="200" fill="#f8fafc"/>
            {/* Боковое меню */}
            <rect x="0" y="0" width="80" height="200" fill="#0f172a"/>
            <rect x="10" y="14" width="60" height="14" rx="3" fill="#10b981"/>
            {[44, 64, 84, 104, 124, 144].map((y, i) => (
                <rect key={i} x="14" y={y} width={50 - i*4} height="6" rx="2" fill="#475569" opacity={i === 1 ? 1 : 0.4}/>
            ))}
            {/* Заголовок */}
            <rect x="100" y="18" width="100" height="10" rx="2" fill="#0f172a"/>
            <rect x="100" y="34" width="160" height="5" rx="2" fill="#cbd5e1"/>
            {/* Карточки статистики */}
            <rect x="100" y="52" width="58" height="34" rx="6" fill="#fff" stroke="#e2e8f0"/>
            <text x="129" y="73" textAnchor="middle" fill="#3b82f6" fontSize="14" fontWeight="800"
                fontFamily="Inter">147</text>
            <text x="129" y="82" textAnchor="middle" fill="#64748b" fontSize="6"
                fontFamily="Inter">учеников</text>

            <rect x="166" y="52" width="58" height="34" rx="6" fill="#fff" stroke="#e2e8f0"/>
            <text x="195" y="73" textAnchor="middle" fill="#10b981" fontSize="14" fontWeight="800"
                fontFamily="Inter">12</text>
            <text x="195" y="82" textAnchor="middle" fill="#64748b" fontSize="6"
                fontFamily="Inter">курсов</text>

            <rect x="232" y="52" width="58" height="34" rx="6" fill="#fff" stroke="#e2e8f0"/>
            <text x="261" y="73" textAnchor="middle" fill="#a855f7" fontSize="14" fontWeight="800"
                fontFamily="Inter">5</text>
            <text x="261" y="82" textAnchor="middle" fill="#64748b" fontSize="6"
                fontFamily="Inter">учителей</text>

            {/* Таблица */}
            <rect x="100" y="100" width="190" height="84" rx="6" fill="#fff" stroke="#e2e8f0"/>
            {[114, 128, 142, 156, 170].map((y, i) => (
                <g key={y}>
                    <circle cx="112" cy={y} r="4" fill="#3b82f6" opacity={0.4 + i*0.12}/>
                    <rect x="124" y={y-3} width="80" height="6" rx="2" fill="#cbd5e1"/>
                    <rect x="220" y={y-3} width="40" height="6" rx="2" fill="#10b981" opacity="0.7"/>
                </g>
            ))}
        </svg>
    );
}
